import $ from 'jquery';
import React from 'react';
import { isMobile } from '../../../../constants/Constants';
import { ABPU_LABELS } from '../../../../constants/Labels';
import { validateField } from '../../../../helpers/tools';
import {
  validate,
  validateInterval,
  validatePercent,
  validateTimecode,
} from '../../../../helpers/adRullesValidators';
import { getLocalStorage, setLocalStorage, parseToFloat } from '../../../../helpers/tools';

class adBreakPopUp extends React.Component {
  constructor(props) {
    super(props);

    const checked = getLocalStorage('AdBreakRow' + this.props.index);
    let checkedOption;

    if (checked === null) {
      checkedOption = this.getDefaultOption(this.props.data);
    } else {
      checkedOption = JSON.parse(checked)[this.props.type];
    }

    this.state = {
      checkedOption,
      key: Math.random(),
    };
  }

  getDefaultOption(data) {
    if (!data) return 'option1';

    const { interval, percents, timecodes } = data;
    if (interval) return 'option1';
    if (percents?.length) return 'option2';
    if (timecodes?.length) return 'option3';
    return 'option1';
  }

  componentDidMount() {
    this.$el = $(this.el);
    function executeValidationOnPopup() {
      let target = this.$el.find('.applyBtn.popUpBtn')[0],
        instances = Number.parseInt(
          $(target.parentNode).find('input[name=instances]')[0].value,
          10
        );
      if (this.$el.hasClass('active') && instances !== 0) {
        this.applyClick({ target: target }, true);
      }
    }

    this.$el.bind('executeValidationOnPopup', executeValidationOnPopup.bind(this));
  }

  /**
   * Method to apply the modefied changes of an ad break pop up
   * @param {event} event
   */
  applyClick = (event, dataFromImport = false) => {
    let applyBtn = $(event.target);

    if (!applyBtn.hasClass('applied')) {
      // eslint-disable-next-line no-shadow
      let adBreakPopUp = $(event.target.parentNode),
        maxAdPodDurationInput = adBreakPopUp.find('input[name=maxAdPodDuration]')[0];
      if (maxAdPodDurationInput) {
        maxAdPodDurationInput.value = parseToFloat(maxAdPodDurationInput.value);
      }

      let instancesInput = adBreakPopUp.find('input[name=instances]')[0],
        result = {
          instances: instancesInput.value,
          maxAdPodDuration:
            maxAdPodDurationInput && maxAdPodDurationInput.value.length
              ? maxAdPodDurationInput.value
              : 0,
        },
        type = this.props.type,
        intervalInput = adBreakPopUp.find('input[name=interval]')[0],
        offsetInput = adBreakPopUp.find('input[name=offset]')[0],
        percentsInput = adBreakPopUp.find('input[name=percents]')[0],
        timecodesInput = adBreakPopUp.find('input[name=timecodes]')[0],
        option = this.state.checkedOption;

      validateField({ target: instancesInput }, 'integer', true, null, 0);

      if (maxAdPodDurationInput) {
        validateField({ target: maxAdPodDurationInput }, 'number', false, null, 0);
      }

      if (type === 'midrolls' || type === 'overlays') {
        result.interval = Number.parseInt(intervalInput.value, 10);
        result.offset = Number.parseInt(offsetInput.value, 10);

        if (percentsInput.value !== '' && option === 'option2') {
          result.percents = percentsInput.value.split(',');
          result.interval = null;
          result.offset = null;
        } else {
          result.percents = [];
        }
        if (timecodesInput.value !== '' && option === 'option3') {
          result.timecodes = timecodesInput.value.split(',');
          result.interval = null;
          result.offset = null;
        } else {
          result.timecodes = [];
        }

        switch (option) {
          case 'option1':
            validateField({ target: intervalInput }, 'number', true, null, 0);
            validateField({ target: offsetInput }, 'number', false, null, 0);
            break;
          case 'option2':
            let floatArray = result.percents.map(item => {
              return parseToFloat(item);
            });
            percentsInput.value = result.percents = floatArray;
            validateField({ target: percentsInput }, 'percents', true);
            break;
          case 'option3':
            validateField({ target: timecodesInput }, 'timecodes', true);
            break;
          default:
            break;
        }
      }

      this.updatePopUpTopPosition(adBreakPopUp);

      if (validate(result, type, option)) {
        if (type === 'midrolls' || type === 'overlays') {
          //adRules is valid - at least one adbreak position is correct,
          //but selected is not valid, we should switch radio button to correct value
          this.setSelected(option);
          switch (option) {
            case 'option1':
              if (!validateInterval(Number.parseInt(intervalInput.value, 10))) {
                this.switchToCorrectValue(
                  intervalInput,
                  percentsInput,
                  timecodesInput,
                  dataFromImport
                );
              }
              break;
            case 'option2':
              if (!validatePercent(percentsInput.value.split(','))) {
                this.switchToCorrectValue(
                  intervalInput,
                  percentsInput,
                  timecodesInput,
                  dataFromImport
                );
              }
              break;
            case 'option3':
              if (!validateTimecode(timecodesInput.value.split(','))) {
                this.switchToCorrectValue(
                  intervalInput,
                  percentsInput,
                  timecodesInput,
                  dataFromImport
                );
              }
              break;
            default:
              break;
          }
        }

        this.props.updateState({
          data: result,
          index: this.props.index,
          type: type,
        });

        if (!dataFromImport) {
          applyBtn.text('Applied');
          applyBtn.addClass('applied');
          this.timeoutID = setTimeout(this.clearApplyBtnTimeout, 1000, applyBtn);
        }
      } else if (dataFromImport) {
        if (type === 'midrolls' || type === 'overlays') {
          this.switchToCorrectValue(intervalInput, percentsInput, timecodesInput, dataFromImport);
        }
      }
    }
  };
  /**
   * Method to selected correct value if exist, if not select interval and display error message
   * @param {object} intervalInput
   * @param {object} percentsInput
   * @param {object} timecodesInput
   */
  switchToCorrectValue = (intervalInput, percentsInput, timecodesInput, dataFromImport) => {
    if (validateInterval(Number.parseInt(intervalInput.value, 10))) {
      this.setSelected('option1');
    } else if (validatePercent(percentsInput.value.split(','))) {
      this.setSelected('option2');
    } else if (validateTimecode(timecodesInput.value.split(','))) {
      this.setSelected('option3');
    } else if (dataFromImport) {
      this.setSelected('option1');
      validateField({ target: intervalInput }, 'number', true, null, 0);
    }
    //to update select view
    this.setState({
      key: Math.random(),
    });
  };

  /**
   * Method to remember selected option (radio button)
   * @param {string} option
   */
  setSelected = option => {
    this.setState({
      checkedOption: option,
    });

    let checked = JSON.parse(getLocalStorage('AdBreakRow' + this.props.index)) || {
      midrolls: 'option1',
      overlays: 'option2',
    };
    checked[this.props.type] = option;
    setLocalStorage('AdBreakRow' + this.props.index, JSON.stringify(checked));
  };

  /**
   * Method to change the active radio button inside an ad break pop up
   * @param {event} event
   */
  changeRadioBtn = event => {
    this.setState({
      checkedOption: event.target.value,
    });

    setTimeout(this.updatePopUpTopPosition, 0, $(event.target).parents('.adBreakPopUp'));
  };

  /**
   * Method to trigger the click event on the document and clear the timeout
   * @param {jquery element} applyBtn
   */
  clearApplyBtnTimeout = applyBtn => {
    if (applyBtn.hasClass('applied')) {
      $(document).trigger(isMobile ? 'touchend' : 'mousedown');
    }
    clearTimeout(this.timeoutID);
  };

  /**
   * Method to update the top position of an ad break pop up
   * @param {jQuery element} adBreakPopUp
   */
  // eslint-disable-next-line no-shadow
  updatePopUpTopPosition = adBreakPopUp => {
    if (adBreakPopUp.css('position') === 'absolute') {
      let adBreakPopUpTransformMatrix = adBreakPopUp.css('transform').split(',');

      /**
       * "43" is the constant value needed to the perfect centring of a ad break pop up.
       * I think it can be calculated somehow by adding padding values, borders etc.
       */
      adBreakPopUpTransformMatrix[5] =
        ' ' + (-adBreakPopUp.height() / 2 - $('.pluginSettingsSection').scrollTop() - 43) + ')';
      adBreakPopUp.css('transform', adBreakPopUpTransformMatrix.join(','));
    } else {
      adBreakPopUp.css('top', 'calc(50% - ' + adBreakPopUp.height() / 2 + 'px)');
    }
  };

  render() {
    return (
      <div key={this.props.key} ref={el => (this.el = el)} className="adBreakPopUp popUp">
        <div>
          <div className="popUpTitle">{ABPU_LABELS[this.props.type].title}</div>
          {(this.props.type === 'midrolls' || this.props.type === 'overlays') && (
            <form className="popUpCheckList" id={'checkList' + this.props.index}>
              <div>
                <input
                  type="radio"
                  name="popup"
                  id={'intervalRadio_' + this.props.type + this.props.index}
                  defaultValue="option1"
                  defaultChecked={this.state.checkedOption === 'option1'}
                  onChange={e => this.changeRadioBtn(e)}
                  key={this.state.key}
                />
                <label htmlFor={'intervalRadio_' + this.props.type + this.props.index}>
                  Interval
                </label>
                <div style={{ display: this.state.checkedOption === 'option1' ? 'block' : 'none' }}>
                  <div className="inputsRow">
                    <div className="bigInput">
                      <input
                        type="number"
                        name="interval"
                        className="textFiled"
                        defaultValue={this.props.data ? this.props.data.interval : ''}
                        key={this.props.data ? this.props.data.interval : ''}
                        min="0"
                      />
                      <div className="validationError"></div>
                    </div>
                  </div>
                  <div className="inputsRow">
                    <div className="bigInput">
                      <label>Offset</label>
                      <input
                        type="number"
                        name="offset"
                        className="textFiled"
                        defaultValue={this.props.data ? this.props.data.offset : ''}
                        key={this.props.data ? this.props.data.offset : ''}
                        min="0"
                      />
                      <div className="validationError"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <input
                  type="radio"
                  name="popup"
                  id={'percentRadio_' + this.props.type + this.props.index}
                  defaultValue="option2"
                  defaultChecked={this.state.checkedOption === 'option2'}
                  onChange={e => this.changeRadioBtn(e)}
                  key={this.state.key}
                />
                <label htmlFor={'percentRadio_' + this.props.type + this.props.index}>
                  Percents
                </label>
                <div style={{ display: this.state.checkedOption === 'option2' ? 'block' : 'none' }}>
                  <div className="inputsRow">
                    <div className="bigInput">
                      <input
                        type="text"
                        name="percents"
                        className="textFiled"
                        defaultValue={this.props.data ? this.props.data.percents : ''}
                        key={this.props.data ? this.props.data.percents : ''}
                      />
                      <div className="validationError"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <input
                  type="radio"
                  name="popup"
                  id={'timecodesRadio_' + this.props.type + this.props.index}
                  defaultValue="option3"
                  defaultChecked={this.state.checkedOption === 'option3'}
                  onChange={e => this.changeRadioBtn(e)}
                  key={this.state.key}
                />
                <label htmlFor={'timecodesRadio_' + this.props.type + this.props.index}>
                  Timecodes
                </label>
                <div style={{ display: this.state.checkedOption === 'option3' ? 'block' : 'none' }}>
                  <div className="inputsRow">
                    <div className="bigInput">
                      <input
                        type="text"
                        name="timecodes"
                        className="textFiled"
                        defaultValue={this.props.data ? this.props.data.timecodes : ''}
                        key={this.props.data ? this.props.data.timecodes : ''}
                      />
                      <div className="validationError"></div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
          <div className="inputsRow">
            <div className="bigInput">
              <label>Instances</label>
              <input
                type="number"
                name="instances"
                className="textFiled"
                defaultValue={this.props.data ? this.props.data.instances : '0'}
                key={this.props.data ? this.props.data.instances : ''}
                min="0"
              />
              <div className="validationError"></div>
            </div>
          </div>
          {this.props.type !== 'overlays' && (
            <div className="inputsRow">
              <div className="bigInput">
                <label>Max AdPod Duration</label>
                <input
                  type="text"
                  name="maxAdPodDuration"
                  className="textFiled"
                  defaultValue={this.props.data ? this.props.data.maxAdPodDuration : '0'}
                  key={this.props.data ? this.props.data.maxAdPodDuration : ''}
                  min="0"
                />
                <div className="validationError"></div>
              </div>
            </div>
          )}
        </div>
        <div className="applyBtn popUpBtn" onClick={this.applyClick}>
          Apply
        </div>
      </div>
    );
  }
}

export default adBreakPopUp;
